// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';

const Image = ({
  pdpAsPath,
  pdpToPath,
  dynamicBadgeOverlayQty,
  mainConfig,
  isVideoUrl,
  imageData,
  TCPStyleType,
  badgeConfig,
  primaryBrand,
  lazyLoadImage,
  isTransparentImageSizeReduceEnabled,
  isPngImage,
}) => {
  const { extraConfig } = React.useContext(LabelsContext);
  const { isDamImageV2EnabledPLP } = extraConfig || {};
  return (
    <Anchor useRouterNavigation to={pdpToPath} asPath={pdpAsPath}>
      <DamImage
        className="product-tile-image"
        imgData={imageData}
        itemProp="contentUrl"
        imgConfigs={mainConfig}
        isProductImage
        isOptimizedVideo={!!isVideoUrl}
        primaryBrand={primaryBrand}
        isDamImageV2EnabledPLP={isDamImageV2EnabledPLP}
        dynamicBadgeOverlayQty={dynamicBadgeOverlayQty}
        tcpStyleType={TCPStyleType}
        badgeConfig={badgeConfig}
        forceWebpForVideo
        lazyLoadImage={lazyLoadImage}
        isPngImage={isPngImage}
        isTransparentImageSizeReduceEnabled={isTransparentImageSizeReduceEnabled}
      />
    </Anchor>
  );
};

Image.propTypes = {
  TCPStyleType: PropTypes.string,
  pdpAsPath: PropTypes.string,
  pdpToPath: PropTypes.string,
  primaryBrand: PropTypes.string,
  badgeConfig: PropTypes.arrayOf(PropTypes.string),
  mainConfig: PropTypes.arrayOf(PropTypes.string),
  imageData: PropTypes.shape({}),
  lazyLoadImage: PropTypes.bool,
  isTransparentImageSizeReduceEnabled: PropTypes.bool,
  isPngImage: PropTypes.bool,
};

Image.defaultProps = {
  TCPStyleType: '',
  pdpAsPath: '',
  pdpToPath: '',
  primaryBrand: '',
  badgeConfig: [],
  mainConfig: [],
  imageData: {},
  lazyLoadImage: false,
  isTransparentImageSizeReduceEnabled: false,
  isPngImage: false,
};

export default Image;
